var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { intersection, sortBy } from "lodash-es";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import devToolMixin from '../../util/devToolMixin';
let EventFilterBar = class EventFilterBar extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.eventFilterString = '';
    this.index = -1;
  }
  clear() {
    this.events = [];
    this.selectedEvents = [];
  }
  isSelected(e) {
    return this.selectedEvents.includes(e.eid);
  }
  clearSelection() {
    this.selectedEvents = [];
  }
  handleIndexChange(index) {
    if (index !== -1 && this.events[index]) {
      this.selectedEvents = [this.events[index].eid];
    } else this.selectedEvents = [];
  }
  handleClick(mouseEvent, e, index) {
    if (mouseEvent.shiftKey) {
      const ordered = sortBy(this.selectedEvents, o => {
        var _this$events$find;
        return (_this$events$find = this.events.find(event => event.eid === o.eid)) === null || _this$events$find === void 0 ? void 0 : _this$events$find.time;
      });
      const startingIndex = this.selectedEvents.length ? this.filteredIds.indexOf(ordered[0]) : 0;
      const endingIndex = this.selectedEvents.length ? this.filteredIds.indexOf(ordered[ordered.length - 1]) : 0;
      if (index > endingIndex) {
        this.selectedEvents = [...this.selectedEvents, ...this.filteredIds.slice(endingIndex, index + 1)];
      } else if (index < startingIndex) {
        this.selectedEvents = [...this.filteredIds.slice(index, startingIndex), ...this.selectedEvents];
      } else {
        this.selectedEvents = intersection(this.selectedEvents, this.filteredIds.slice(0, index + 1));
      }
    } else {
      if (this.isSelected(e)) {
        this.selectedEvents = this.selectedEvents.filter(id => id !== e.eid);
      } else if (mouseEvent.metaKey || mouseEvent.ctrlKey) {
        this.selectedEvents = [...this.selectedEvents, e.eid];
      } else {
        this.selectedEvents = [e.eid];
        this.index = index;
      }
    }
    this.activeCompPath = e.compPath;
  }
  get filtered() {
    return this.events.filter(e => {
      var _e$args, _e$compInstance;
      return [e.eventId, e.compPath, e.name, ...((_e$args = e.args) === null || _e$args === void 0 ? void 0 : _e$args.filter(arg => typeof arg === 'string')), (_e$compInstance = e.compInstance) === null || _e$compInstance === void 0 ? void 0 : _e$compInstance.$attrs['']].some(el => el.includes(this.eventFilterString));
    });
  }
  get filteredIds() {
    return this.filtered.map(e => e.eid);
  }
  get panel() {
    const h = this.$createElement;
    if (this.events.length) {
      return this.filtered.map((e, index) => {
        var _e$compInstance2;
        // const isBind = ['input', 'change'].includes(e.eventId);
        const isBind = false;
        return h("div", {
          "class": `ucd-devTool-timeline-eventPanel-eventline
              ${this.isSelected(e) ? 'selected' : ''}`,
          "on": {
            "click": mouseEvent => this.handleClick(mouseEvent, e, index)
          }
        }, [h("div", {
          "class": "content"
        }, [h("span", {
          "style": {
            color: isBind ? 'red' : 'darkseagreen'
          }
        }, [" ", e.eventId, " "]), h("span", [" $", isBind ? 'bind' : 'emit', " by "]), h("span", {
          "style": {
            color: 'orange'
          }
        }, [`${(e === null || e === void 0 || (_e$compInstance2 = e.compInstance) === null || _e$compInstance2 === void 0 ? void 0 : _e$compInstance2.$attrs['data-uc-type']) || ''} ${e.name}`])]), h("div", {
          "class": "time"
        }, [e.time])]);
      });
    }
    return h("div", {
      "class": "ucd-devTool-timeline-eventPanel-empty"
    }, [this.bus.options.recording ? '正在监听事件...' : '请手动开启事件监听...']);
  }
  handleKeydown(e) {
    if (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') return;
    if (e.target.isContentEditable) return;
    if (this.selectedEvents.length > 1) return;
    switch (e.keyCode) {
      case 37:
        // 左
        this.index = 0;
        break;
      case 39:
        // 右
        this.index = this.events.length - 1;
        break;
      case 40:
        // 下
        this.index = this.index === this.events.length - 1 ? 0 : this.index + 1;
        break;
      case 38:
        // 上
        this.index = this.index === 0 ? this.events.length - 1 : this.index - 1;
        break;
    }
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-timeline-eventPanel",
      "attrs": {
        "tabindex": "0"
      },
      "on": {
        "keydown": this.handleKeydown
      }
    }, [h("a-input", {
      "attrs": {
        "placeholder": "过滤事件",
        "allowClear": true
      },
      "class": "filter",
      "model": {
        value: this.eventFilterString,
        callback: $$v => {
          this.eventFilterString = $$v;
        }
      }
    }, [h("a-icon", {
      "slot": "prefix",
      "attrs": {
        "type": "search"
      }
    }), h("span", {
      "slot": "addonAfter",
      "class": "actions"
    }, [h("a-icon", {
      "attrs": {
        "type": "stop",
        "theme": "twoTone",
        "twoToneColor": this.events.length ? 'green' : 'gray'
      },
      "on": {
        "click": this.clear
      },
      "style": {
        cursor: this.events.length ? 'pointer' : 'not-allowed'
      }
    }), h("a-icon", {
      "attrs": {
        "type": "video-camera",
        "theme": "twoTone",
        "twoToneColor": this.bus.options.recording ? 'red' : 'gray'
      },
      "on": {
        "click": () => {
          if (!this.manualDisable && this.bus.options.recording) this.manualDisable = true;
          this.bus.$set(this.bus.options, 'recording', !this.bus.options.recording);
        }
      }
    })])]), h("div", {
      "class": "panel"
    }, [this.panel]), this.selectedEvents.length > 1 && h("div", {
      "class": "clear-selection",
      "on": {
        "click": this.clearSelection
      }
    }, ["\u6E05\u7A7A\u9009\u4E2D"])]);
  }
};
__decorate([Watch('index')], EventFilterBar.prototype, "handleIndexChange", null);
EventFilterBar = __decorate([Component({
  name: 'EventFilterBar',
  model: {
    prop: 'events',
    event: 'change'
  }
})], EventFilterBar);
export default EventFilterBar;